export type Nullable<T> = T | null | undefined;

export const isNullish = (value: Nullable<unknown>): value is null | undefined =>
  value === null || value === undefined;
